import React, {useEffect} from "react";
import PrivacyText from "@/components/privacy-text";
import {iframeStyling, privacyPolicy} from "@/components/support/styles/support-iframe";
import Script from "next/script"

const SupportFAQ: React.FC = () => {

    return (
        <section>
            <div className={privacyPolicy}>
                <PrivacyText/>
            </div>

            {/*FAQ iframe script*/}
            <Script>
                {`var s = document.createElement("script");
                        s.type = "text/javascript";
                        s.async = true;
                        s.src = "https://embedder.upraise.io/ext/widget/inline_embed.js?embedType=2&widgetId=9eca9680-77f2-11eb-bfcd-adefafe9687c&clientKey=9b13c6b6-37ba-3b68-ab52-1c00641b4b45";
                        s.onload = s.onreadystatechange = function () {
                        // can add logic to load widget or not
                        var wh = new window.embedConfluenceWidget();
                    };
                        var h = document.getElementsByTagName("head")[0];
                        h.appendChild(s);`}
            </Script>
        <style>{`iframe {max-height: 518px; max-width: 100%}`}</style>
            <div className={iframeStyling}>
                <div id="embedder-inline-embed-widget-2" />
            </div>

        </section>
    )
}

export default SupportFAQ



